<template>
  <el-table-column
    v-bind="$attrs"
  >
    <template slot-scope="scope">
      <span v-if="$attrs.dataType === 'date'">
        {{ formatDate(scope.row[$attrs.prop]) }}
      </span>
      <img v-else-if="$attrs.dataType === 'image'" :src="getImage(scope.row[$attrs.prop])" />
      <span v-else-if="$attrs.type ==='expand'">
        <template>
          <el-table
            :data="scope.row[$attrs.prop]"
            style="width: 100%">
            <el-table-column
              sortable
              align="center"
              v-for="(field, idx) in $attrs.fields"
              :key="idx"
              :prop="field.prop"
              :label="field.label"
              :formatter="(row, column, cellValue) => field.format_score ? field.format_score(cellValue): cellValue"
              >
            </el-table-column>
          </el-table>
        </template>
      </span>
      <span v-else-if="canShowSpecialAssessmentTest(scope, $attrs)">
        {{scope.row["org_assessment_test"]}}
        <el-button
          class="assessment-detail-btn"
          v-if="canShowButton(scope, $attrs)"
          @click.native.prevent="handleShowAssessment(scope.$index, scope.row)" @click.stop>{{$attrs.labelButton}}
        </el-button>
      </span>
      <span v-else>
        {{ $attrs.formatter ? $attrs.formatter(scope.row, scope.column, scope.row[$attrs.prop], scope.$index ) : scope.row[$attrs.prop] }}
        <el-button
          class="assessment-detail-btn"
          v-if="canShowButton(scope, $attrs)"
          @click.native.prevent="$attrs.prop == 'last_eps' ? handleShowLessonsDetail(scope.$index, scope.row) : handleShowAssessment(scope.$index, scope.row) " @click.stop>{{$attrs.labelButton}}
        </el-button>
      </span>
    </template>
  </el-table-column>
</template>

<script>
  import { format } from 'date-fns'

  export default {
    props: {
      dateFormat: {
        type: String,
        default: 'MM/dd/yyyy'
      },
    },
    methods: {
      canShowButton(scope, $attrs) {
        const isShowBase = $attrs.showButton && scope.row[$attrs.prop] > 0 && scope.row.id == $attrs.currIdHovering;
        if ($attrs.prop == 'last_eps') {
          return isShowBase && scope.row["time_spent"];
        }
        return isShowBase;
      },
      formatDate(date) {
        return date ? format(new Date(date), this.dateFormat) : '--'
      },
      getImage(value) {
        return value ? require('@/assets/images/pro-licence.svg') : require('@/assets/images/no-pro-licence.svg')
      },
      handleShowAssessment(index, row) {
        return this.$emit("handleShowAssessment", row)
      },
      handleShowLessonsDetail(index, row) {
        return this.$emit("handleShowLessonsDetail", row)
      },
      canShowSpecialAssessmentTest(scope, $attrs) {
        let org_assessment_test = scope.row["org_assessment_test"];
        return $attrs.prop == 'org_assessment_test' && org_assessment_test > 0;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";
  span {
    font-weight: 500;
    font-size: 18px;
    color: $black;
  }
  .assessment-detail-btn {
    padding: 5px 5px;
  }
</style>
